import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import apis from 'config/apis';
import tools from 'common/tools';
import { ubtSendMetric } from 'utils/ubt';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pvId: '',
    debugMode: false,
    debugData: '',
    debugInfos: [],
    pageNow: '',
    gridName: '',
    authNodeData: [],
    maxServiceVer: '',
    homeHidden: true,
    lanChange: true,
    searchHidden: true,
    userInfo: {},
    currentUser: '',
    searchValue: '',
    showSearch: true,
    showSidebar: false,
    showFooter: false,
    footerTips: '',
    downloadSource: '',
    footerWarn: '',
    errorStatus: false,
    languageDatas: {},
    languages: {},
    grayList: [],
    softTypeList: [],
    activeTabId: 'recommend',
    authSoftList: [],
    softTotalDetailDatas: [],
    recommendSoftware: [],
    recommendSoftwareEn: [],
    serviceList: [],
    toolList: [],
    updateList: [],
    serviceVersion: '',
    selectSoftDetails: [],
    upgradeSoftDetails: [],
    upgradeSoftCount: 0,
    softVersion: '',
    softCount: 0,
    isTestUser: false,
    testTypeId: 0,
    licenseTypeId: '',
    licenseSoftList: [],
    isRunning: false,
    isTripPc: false,
    errorType: '',
    softRankingList: [],
    uninstallData: {},
    authInterval: false,
    errorTips: '',
    warnTips: '',
    deployCount: 0,
    fixCount: 0,
    deployTask: [],
    fixTask: [],
    debugList: [],
    isAuthTab: false,
    internetAuth: '',
    isAdministrator: false,
    redirectMode: false,
    isT: false,
    notS: false,
    isSeven: false,
    isLaptopUser: false,
    UacStatus: '',
    adobeAll: false,
    leaderAndCostCenter: '',
    socketStatus: [],
    isNewService: true,
    isErrorPage: false,
    socketIniting: false,
    upgradeChecking: false,
    modelError: false,
    webDialogVisible: false,
    userLicenses: [],
    isVpUser: false,
    isCostUser: false,
    remedyIncNo: '',
    localDomain: '',
    uninstallLoadingFlag: false,
    uninstallSearchValue: '',
    uninstallSoftwareList: [],
    oldUninstallBtnShowFlag: false,
    batteryRedirectFlag: false,
    applyAdminPermission: false,
    showDiskWipe: false,
    deviceName: '',
    headers: {},
    mockMode: false,
  },
  mutations: {
    setPvId(state, pvId) {
      state.pvId = pvId;
    },
    setIsVpUser(state, status) {
      state.isVpUser = status;
    },
    setIsCostUser(state, status) {
      state.isCostUser = status;
    },
    setWebDialogVisible(state, status) {
      state.webDialogVisible = status;
    },
    setIsNewService(state, status) {
      state.isNewService = status;
    },
    setSocketStatus(state, data) {
      state.socketStatus = data;
    },
    setUpgradeChecking(state, status) {
      state.upgradeChecking = status;
    },
    setModelError(state, status) {
      state.modelError = status;
    },
    setSocketIniting(state, status) {
      state.socketIniting = status;
    },
    setShowWipe(state, mode) {
      state.showDiskWipe = mode;
    },
    setRedirectMode(state, mode) {
      console.log('current page', state.pageNow, ', redirectMode', mode);
      state.redirectMode = mode;
    },
    setDebugMode(state, mode) {
      state.debugMode = mode;
    },
    setDebugData(state, data) {
      state.debugData = data;
    },
    setLanChange(state, mode) {
      state.lanChange = mode;
    },
    setDebugInfos(state, data) {
      const date = tools.getFormatDate(new Date());
      const name = data[0];
      let desc = data[1];
      if (Object.prototype.toString.call(desc) === '[object Object]') {
        desc = JSON.stringify(desc);
      } else {
        desc = desc === undefined ? 'null' : desc.toString();
      }
      state.debugInfos.push({ date, name, desc });
    },
    setIsT(state, status) {
      state.isT = status;
    },
    setNotS(state, status) {
      state.notS = status;
    },
    setIsSeven(state, status) {
      state.isSeven = status;
    },
    setLaptopUser(state, status) {
      state.isLaptopUser = status;
    },
    setAuthTap(state, type) {
      state.isAuthTab = type;
    },
    setPageNow(state, pageName) {
      state.pageNow = pageName;
    },
    setGridName(state, name) {
      state.gridName = name;
    },
    setErrorTips(state, data) {
      state.errorTips = data;
    },
    setWarnTips(state, data) {
      state.warnTips = data;
    },
    setDeployCount(state, count) {
      state.deployCount = count;
    },
    setFixCount(state, count) {
      state.fixCount = count;
    },
    setDeployTask(state, tasks) {
      state.deployTask = tasks;
    },
    setFixTask(state, tasks) {
      state.fixTask = tasks;
    },
    setTestUser(state, type) {
      state.isTestUser = type;
    },
    setTestTypeId(state, id) {
      state.testTypeId = id;
    },
    setLicenseTypeId(state, id) {
      state.licenseTypeId = id;
    },
    setAuthNodeData(state, data) {
      state.authNodeData = data;
    },
    setMaxServiceVer(state, ver) {
      state.maxServiceVer = ver;
    },
    setLanguageDatas(state, languageDatas) {
      state.languageDatas = languageDatas;
    },
    setLanguage(state, languages) {
      state.languages = languages;
    },
    setGrayList(state, list) {
      state.grayList = list;
    },
    seterrorStatus(state, payload) {
      state.errorStatus = payload.status;
    },
    setDeviceName(state, name) {
      state.deviceName = name;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser;
    },
    setSoftSearch(state, search) {
      state.searchValue = search;
    },
    setShowSearch(state, show) {
      state.showSearch = show;
    },
    setShowSidebar(state, show) {
      state.showSidebar = show;
    },
    setShowFooter(state, show) {
      state.showFooter = show;
    },
    setFooterTips(state, tips) {
      state.footerTips = tips;
    },
    setsoftRankingList(state, list) {
      state.softRankingList = list;
    },
    setDownloadSource(state, source) {
      state.downloadSource = source;
    },
    setFooterWarn(state, warn) {
      state.footerWarn = warn;
    },
    setSoftVersion(state, res) {
      state.softVersion = String(res.version);
    },
    setUninstallData(state, data) {
      state.uninstallData = data;
    },
    setSoftType(state, res) {
      const softTypes = tools.sortByKey(res, 'seq');
      softTypes.unshift({ id: 'common', name: state.languages.softInstall.common });
      const recommendList =
        state.languages.lan === 'cn' ? state.recommendSoftware : state.recommendSoftwareEn;
      if (recommendList.length > 0) {
        softTypes.unshift({ id: 'recommend', name: state.languages.softInstall.suggest });
      }
      state.softTypeList = softTypes;
    },
    setSoftTabPage(state, id) {
      state.activeTabId = id;
    },
    setSoftDetails(state, res) {
      const licenseSoftList = []; // for MyLicenseDialog  Adobe All Return
      if (res == null) {
        return;
      }
      const totalDatas = res.map((item) => {
        const soft = item;
        if (soft.typeId === this.state.licenseTypeId && soft.name.indexOf('Adobe') > -1) {
          licenseSoftList.push(soft);
        }
        const authList = state.authSoftList;
        const index = authList.findIndex((itm) => soft.id === itm.softwareId);
        if (index !== -1) {
          /* 0: install button; 1: apply button; 2: applying button */
          if (authList[index].status < 0) {
            soft.authority = 1;
          } else if (authList[index].status === 0) {
            soft.authority = 2;
          } else {
            soft.authority = 0;
          }
          soft.progress = authList[index].progress;
          soft.applyId = authList[index].applyId;
          soft.urgeTimes = authList[index].urgeTimes;
          soft.lastUpdateTime = authList[index].updateTime;
        }
        return soft;
      });
      state.softTotalDetailDatas = totalDatas;
      state.licenseSoftList = licenseSoftList;
    },
    setServiceList(state, res) {
      state.serviceList = res;
    },
    setToolList(state, res) {
      state.toolList = res;
    },
    setUpdateList(state, res) {
      state.updateList = res;
    },
    setServiceVersion(state, res) {
      state.serviceVersion = res;
    },
    updateSoftDetails(state, item) {
      const index = state.softTotalDetailDatas.findIndex((itm) => itm.id === item.index);
      if (index !== -1) {
        state.softTotalDetailDatas[index][item.key] = item.val;
      }
      const idx = state.selectSoftDetails.findIndex((itm) => itm.id === item.index);
      if (idx !== -1) {
        state.selectSoftDetails[idx][item.key] = item.val;
      }
    },
    setUpgradeSoftDetails(state, item) {
      state.upgradeSoftDetails = item;
    },
    setUpgradeSoftCount(state, count) {
      state.upgradeSoftCount = count;
    },
    setAuthSoftList(state, res) {
      state.authSoftList = res;
    },
    setAuthInterval(state, type) {
      state.authInterval = type;
    },
    setAdobeAll(state, status) {
      state.adobeAll = status;
    },
    setLeaderAndCostCenter(state, data) {
      state.leaderAndCostCenter = data;
    },
    setAuthSoftDatas(state, data) {
      const totalDatas = data.map((item) => {
        const soft = item;
        const authList = state.authSoftList;
        const index = authList.findIndex((itm) => soft.id === itm.softwareId);
        if (index !== -1) {
          soft.progress = authList[index].progress;
          soft.lastUpdateTime = authList[index].updateTime;
        }
        return soft;
      });
      state.selectSoftDetails = totalDatas;
    },
    setSelectSoftDetails(state, id) {
      if (id === 'softUpgrade') {
        state.softCount = state.upgradeSoftDetails.length;
        return;
      }
      if (id === 'recommend') {
        const recommendFilterData = state.softTotalDetailDatas.filter((item) => {
          const soft = item;
          const recommendList =
            state.languages.lan === 'cn' ? state.recommendSoftware : state.recommendSoftwareEn;
          const findIndex = recommendList.findIndex((itm) => {
            if (itm.soft_id === soft.id) {
              soft.installCount = itm.num;
              return true;
            }
            return false;
          });
          return findIndex !== -1;
        });
        state.selectSoftDetails = recommendFilterData.sort(
          (a, b) => b.installCount - a.installCount,
        );
      } else if (id === 'common') {
        const commonFilterDatas = state.softTotalDetailDatas.filter((item) => item.recommend === 1);
        state.selectSoftDetails = tools.sortByKey(commonFilterDatas, 'seq');
      } else {
        const filterDatas = state.softTotalDetailDatas.filter((item) => item.typeId === id);
        state.selectSoftDetails = tools.sortByKey(filterDatas, 'softSeq');
      }
      if (state.gridName !== 'Program Push' && state.gridName !== 'Patch Update') {
        state.softCount = state.selectSoftDetails.length;
      }
      // 商业软件，增加Adobe全部权限判断和Figma权限预判断
      if (state.isAuthTab) {
        state.selectSoftDetails = state.selectSoftDetails.map((item) => {
          const soft = item;
          if (state.adobeAll && soft.name.toUpperCase().indexOf('ADOBE') > -1 && soft.softType === 1) {
            soft.authority = 0;
            soft.progress = 4;
          }
          if (state.figmaPermissionList.includes(soft.id)) {
            soft.authority = 0;
            soft.progress = 4;
          }
          return soft;
        });
      }
    },
    setSoftCount(state, count) {
      state.softCount = count;
    },
    setIsRunning(state, status) {
      state.isRunning = status;
    },
    setHomeHidden(state, status) {
      state.homeHidden = status;
    },
    setSearchHidden(state, status) {
      state.searchHidden = status;
    },
    handleSoftSearch(state, searchVal) {
      if (searchVal.trim() !== '') {
        let copyTotalDetailDatas = {};
        copyTotalDetailDatas = JSON.parse(JSON.stringify(state.softTotalDetailDatas));
        const searchResult = copyTotalDetailDatas.filter((item) => {
          if (state.isTestUser) {
            if (item.search.toUpperCase().indexOf(searchVal.toUpperCase()) !== -1) return item;
          } else if (
            item.typeId !== state.testTypeId &&
            item.search.toUpperCase().indexOf(searchVal.toUpperCase()) !== -1
          ) {
            return item;
          }
          return false;
        });
        searchResult.map((item) => {
          const soft = item;
          const index = state.softTypeList.findIndex((type) => soft.typeId === type.id);
          if (index !== -1) {
            const remark = state.softTypeList[index].name;
            soft.description += ` (${remark})`;
          }
          return soft;
        });
        state.selectSoftDetails = searchResult;
        state.softCount = searchResult.length;
      } else {
        this.commit('setSelectSoftDetails', state.activeTabId);
      }
    },
    setIsTripPc(state, status) {
      state.isTripPc = status;
    },
    setHeaders(state, token) {
      state.headers = { headers: { accessToken: token } };
    },
    setErrorType(state, type) {
      state.errorType = type;
      state.isErrorPage = true;
    },
    setInternetAuth(state, status) {
      state.internetAuth = status ? 1 : 0;
    },
    setIsAdministrator(state, status) {
      state.isAdministrator = status;
    },
    setUacStatus(state, status) {
      state.UacStatus = status;
    },
    setRecommendSoftware(state, data) {
      state.recommendSoftware = data;
    },
    setRecommendSoftwareEn(state, data) {
      state.recommendSoftwareEn = data;
    },
    setUserLicenses(state, data) {
      state.userLicenses = data;
    },
    setRemedyIncNo(state, data) {
      state.remedyIncNo = data;
    },
    setLocalDomain(state, data) {
      state.localDomain = data;
    },
    setUninstallLoadingFlag(state, data) {
      state.uninstallLoadingFlag = data;
    },
    setUninstallSearch(state, data) {
      state.uninstallSearchValue = data;
    },
    setUninstallSoftwareList(state, data) {
      state.uninstallSoftwareList = data;
    },
    setOldUninstallBtnShowFlag(state, data) {
      const softMoudleList = data[0].children;
      const uninstallMoudleIdx = softMoudleList.findIndex((v) => v.route === 'software_uninstall');
      if (uninstallMoudleIdx > -1) {
        const uninstallVisible = softMoudleList[uninstallMoudleIdx].visible;
        if (uninstallVisible === 0) {
          state.oldUninstallBtnShowFlag = true;
        }
      } else {
        state.oldUninstallBtnShowFlag = true;
      }
    },
    setBatteryRedirectFlag(state, data) {
      state.batteryRedirectFlag = data;
    },
    setApplyAdminPermission(state, data) {
      state.applyAdminPermission = data;
    },
    setFigmaPermission(state, data) {
      state.figmaPermissionList = data;
    },
  },
  actions: {
    async getSoftSearch({ state }, searchVal) {
      try {
        if (searchVal.trim() !== '') {
          const timeStart = new Date();
          const url = `${apis.getSoftware}?name=${searchVal}&lan=${state.languages.lan}&empCode=${state.userInfo.empcode}`;
          const { data: res, headers } = await axios.get(url, this.state.headers);
          const timeCost = new Date().getTime() - timeStart.getTime();
          if (res.code === 1) {
            ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, true);
            if (res.data.length > 0) {
              const softDatas = res.data;
              if (state.authSoftList.length > 0) {
                softDatas.forEach((item) => {
                  const soft = item;
                  const authList = state.authSoftList;
                  const index = authList.findIndex((itm) => soft.id === itm.softwareId);
                  if (index !== -1) {
                    /* 0: install button; 1: apply button; 2: applying button */
                    // soft.authority = authList[index].status === 0 ? 2 : 0;
                    if (authList[index].status < 0) {
                      soft.authority = 1;
                    } else if (authList[index].status === 0) {
                      soft.authority = 2;
                    } else {
                      soft.authority = 0;
                    }
                    soft.progress = authList[index].progress;
                    soft.lastUpdateTime = authList[index].updateTime;
                  }
                });
              }
              // for querrAdobeAll
              if (state.adobeAll) {
                softDatas.forEach((item) => {
                  const soft = item;
                  if (soft.name.toUpperCase().indexOf('ADOBE') > -1 && soft.softType === 1) {
                    soft.authority = 0;
                    soft.progress = 4;
                  }
                });
              }
              softDatas.map((item) => {
                const soft = item;
                const index = state.softTypeList.findIndex((type) => soft.typeId === type.id);
                if (index !== -1) {
                  const remark = state.softTypeList[index].name;
                  soft.description += ` (${remark})`;
                }
                return soft;
              });
              state.selectSoftDetails = softDatas;
              state.softCount = res.data.length;
            } else {
              state.selectSoftDetails = [];
              state.softCount = 0;
            }
          } else {
            ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, false);
          }
        } else {
          this.commit('setSelectSoftDetails', state.activeTabId);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getLanguageData(context) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(apis.getLanguages, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.getLanguages, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getLanguageData failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getLanguages, headers.rootmessageid, timeCost, true);
        context.commit('setLanguageDatas', res.data.languages);
        return { status: 'success' };
      } catch (error) {
        console.log('error=================================', error);
        return { status: 'failed', data: error };
      }
    },
    async getAuthNode(context) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(apis.getAuthNode, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.getAuthNode, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getAuthNode failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getAuthNode, headers.rootmessageid, timeCost, true);
        // console.log('authNodeData', JSON.stringify(res.data.authNodeData));
        const isTestUser = res.data.authNodeData.some((item) => {
          const hasTest = item.children.some((itm) => itm.ename === 'TEST' && itm.visible === 1);
          return hasTest;
        });

        const info = { desktopNum: this.state.deviceName, empCode: this.state.userInfo.empcode };
        const dataClearCheckStart = new Date();
        const { data: rst } = await axios.post(apis.dataClearCheck, info, this.state.headers);
        const dataClearCheckTime = new Date().getTime() - dataClearCheckStart.getTime();
        ubtSendMetric(
          this.pvId,
          apis.dataClearCheck,
          headers.rootmessageid,
          dataClearCheckTime,
          true,
        );
        let showDiskWipe = rst.code === 1 ? rst.data : false;
        context.commit('setTestUser', isTestUser);
        context.commit('setShowWipe', showDiskWipe);
        if (isTestUser) showDiskWipe = true;
        context.commit('setGrayList', res.data);
        context.commit('setAuthNodeData', res.data.authNodeData);
        context.commit('setMaxServiceVer', res.data.maxServiceVer);
        context.commit('setOldUninstallBtnShowFlag', res.data.authNodeData);
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getInternetAuth(context) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(apis.getInternetAuth, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        console.log('getInternetAuth', res);
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.getInternetAuth, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getInternetAuth failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getInternetAuth, headers.rootmessageid, timeCost, true);
        context.commit('setInternetAuth', res.data);
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getVoteSoft() {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(apis.getVoteSoft, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.getVoteSoft, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getVoteSoft failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getVoteSoft, headers.rootmessageid, timeCost, true);
        return { status: 'success', data: res.data };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async toVoteSoft(context, soft) {
      try {
        const timeStart = new Date();
        const url = `${apis.voteSoft}?softName=${soft}`;
        const { data: res, headers } = await axios.get(url, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getVoteSoft failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, true);
        return 'success';
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getSoftRankingList(context) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(apis.getSoftRankingList, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.getSoftRankingList, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getSoftRankingList failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getSoftRankingList, headers.rootmessageid, timeCost, true);
        context.commit('setsoftRankingList', res.data);
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getSoftVersion(context, lan) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          apis.getSoftVersion + lan,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(
            this.pvId,
            apis.getSoftVersion + lan,
            headers.rootmessageid,
            timeCost,
            false,
          );
          return { status: 'failed', data: `getSoftVersion failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getSoftVersion + lan, headers.rootmessageid, timeCost, true);
        context.commit('setSoftVersion', res.data);
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getSoftTypes(context, lan) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(apis.getSoftTypes + lan, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.getSoftTypes + lan, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getSoftTypes failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getSoftTypes + lan, headers.rootmessageid, timeCost, true);
        const typeList = res.data;
        // for Software Test Users
        const testIndex = typeList.findIndex((item) => item.name === 'test');
        const licenseIndex = typeList.findIndex(
          (item) => item.name === 'License' ||
            item.name === context.state.languageDatas.cnpack.softInstall.license,
        );
        if (licenseIndex !== -1) context.commit('setLicenseTypeId', typeList[licenseIndex].id);
        if (testIndex !== -1 && !this.state.isTestUser) {
          context.commit('setTestTypeId', typeList[testIndex].id);
          typeList.splice(testIndex, 1);
        }
        context.commit('setSoftType', typeList);
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getTypeList(context, lan) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(apis.getSoftTypes + lan, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.getSoftTypes + lan, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getSoftTypes failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getSoftTypes + lan, headers.rootmessageid, timeCost, true);
        return { status: 'success', data: res.data };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async userAuthQuery(context, datas) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.post(
          apis.authSoftQuery,
          datas,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.authSoftQuery, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `userAuthQuery failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.authSoftQuery, headers.rootmessageid, timeCost, true);
        // soft.status   0: Applying 1: Install 2: Apply   -1: Cancel   -2: Refuse  -3: Recyled
        const authList = res.data.map((item) => {
          const soft = item;
          if (soft.status < 0) soft.status = 2;
          return item;
        });
        context.commit('setAuthSoftList', authList);
        context.commit('setAuthInterval', false);
        res.data.forEach((item) => {
          if (item.status === 0 || (item.progress > 0 && item.progress < 4)) {
            context.commit('setAuthInterval', true);
          }
        });
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async queryAdobeAll(context, empCode) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          `${apis.adobeAll}?empCode=${empCode}`,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code && res.code === 1) {
          ubtSendMetric(
            this.pvId,
            `${apis.adobeAll}?empCode=${empCode}`,
            headers.rootmessageid,
            timeCost,
            true,
          );
          context.commit('setAdobeAll', res.data);
        }
      } catch (error) {
        console.log('error in queryAdobeAll', error);
      }
    },
    async isRelateSoftware(context, id) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          `${apis.isRelateSoftware}?softwareId=${id}`,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code && res.code === 1) {
          ubtSendMetric(
            this.pvId,
            `${apis.isRelateSoftware}?softwareId=${id}`,
            headers.rootmessageid,
            timeCost,
            true,
          );
          return res.data;
        }
        return false;
      } catch (error) {
        console.log('error in isRelateSoftware', error);
        return false;
      }
    },
    async isLightApprove(context, id) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          `${apis.isLightApprove}?softwareId=${id}`,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code && res.code === 1) {
          ubtSendMetric(
            this.pvId,
            `${apis.isLightApprove}?softwareId=${id}`,
            headers.rootmessageid,
            timeCost,
            true,
          );
          return res.data;
        }
        return false;
      } catch (error) {
        console.log('error in isLightApprove', error);
        return false;
      }
    },
    async urgeActive(context, id) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          `${apis.urgeActive}?applyId=${id}`,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code && res.code === 1) {
          ubtSendMetric(
            this.pvId,
            `${apis.urgeActive}?applyId=${id}`,
            headers.rootmessageid,
            timeCost,
            true,
          );
          return 'success';
        }
        context.commit('setDebugInfos', ['urgeActive Error', res.msg]);
        return res.msg;
      } catch (error) {
        context.commit('setDebugInfos', ['urgeActive Error', error]);
        return error;
      }
    },
    async getLeaderAndCostCenter(context) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          apis.getLeaderAndCostCenter,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code && res.code === 1) {
          ubtSendMetric(
            this.pvId,
            apis.getLeaderAndCostCenter,
            headers.rootmessageid,
            timeCost,
            true,
          );
          if (
            res.data.costCode &&
            res.data.costCode.toUpperCase() === this.state.userInfo.empcode.toUpperCase()
          ) {
            context.commit('setIsCostUser', true);
          }
          context.commit('setLeaderAndCostCenter', res.data);
        }
      } catch (error) {
        console.log('error in getLeaderAndCostCenter', error);
      }
    },
    async getSoftDetails(context, lan) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          apis.getSoftDetails + lan,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        // console.log('getSoftDetails >>>>> ', res.data);
        if (res.code !== 1) {
          ubtSendMetric(
            this.pvId,
            apis.getSoftDetails + lan,
            headers.rootmessageid,
            timeCost,
            false,
          );
          return { status: 'failed', data: `getSoftDetails failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getSoftDetails + lan, headers.rootmessageid, timeCost, true);
        /* method for AuthSoftware Filter */
        if (!res.data) {
          return { status: 'failed', data: 'data is null' };
        }
        context.commit('setSoftDetails', res.data);
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getServiceList(context, lan) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          apis.getSoftDetails + lan,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(
            this.pvId,
            apis.getSoftDetails + lan,
            headers.rootmessageid,
            timeCost,
            false,
          );
          return { status: 'failed', data: `getServiceList failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getSoftDetails + lan, headers.rootmessageid, timeCost, true);
        context.commit('setServiceList', res.data);
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getToolList(context, lan) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          apis.getSoftDetails + lan,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(
            this.pvId,
            apis.getSoftDetails + lan,
            headers.rootmessageid,
            timeCost,
            false,
          );
          return { status: 'failed', data: `getToolList failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getSoftDetails + lan, headers.rootmessageid, timeCost, true);
        context.commit('setToolList', res.data);
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getUpdateList(context) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(apis.getUpdateInfo, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.getUpdateInfo, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getUpdateList failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getUpdateInfo, headers.rootmessageid, timeCost, true);
        context.commit('setUpdateList', res.data);
        return res.data;
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getTripPc(context, pcname) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(apis.getTripPc + pcname, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.getTripPc + pcname, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getTripPc failed:${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getTripPc + pcname, headers.rootmessageid, timeCost, true);
        if (res.data === true) {
          context.commit('setIsTripPc', true);
        }
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getUserDetails(context, code) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.post(
          apis.getUserInfo,
          { code },
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.getUserInfo + code, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getUserDetails failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getUserInfo + code, headers.rootmessageid, timeCost, true);
        context.commit('setUserInfo', res.data);
        context.commit('setHeaders', res.data.accessToken);
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async softwareInstall(context, datas) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.post(
          apis.softTaskCreate,
          datas,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.softTaskCreate, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `softTaskCreate failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.softTaskCreate, headers.rootmessageid, timeCost, true);
        return { status: 'success', data: res.data };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async softwareApply(context, datas) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.post(
          apis.authSoftApply,
          datas,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        console.log('softwareApply', res);
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.authSoftApply, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `softwareApply failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.authSoftApply, headers.rootmessageid, timeCost, true);
        return { status: 'success' };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getCheckInfo(context, data) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          apis.getCheckInfo + data,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(
            this.pvId,
            apis.getCheckInfo + data,
            headers.rootmessageid,
            timeCost,
            false,
          );
          return { status: 'failed', data: `getCheckInfo failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.getCheckInfo + data, headers.rootmessageid, timeCost, true);
        return { status: 'success', data: res.data };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async hwCheck() {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(apis.hwCheck, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, apis.hwCheck, headers.rootmessageid, timeCost, false);
          return { status: 'failed', data: `getCheckInfo failed: ${res.msg}` };
        }
        ubtSendMetric(this.pvId, apis.hwCheck, headers.rootmessageid, timeCost, true);
        return { status: 'success', data: res.data };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async softApply(context, datas) {
      try {
        let method = '';
        let url = '';
        switch (datas.type) {
          case 'add':
            method = 'post';
            url = `${apis.softwareApplication}add`;
            break;
          case 'cityinfo':
            method = 'get';
            url = `${apis.softwareApplication}getCityInfo`;
            break;
          case 'baseinfo':
            method = 'get';
            url = `${apis.softwareApplication}getEmpBaseInfo`;
            break;
          case 'queryinc':
            method = 'get';
            url = `${apis.softwareApplication}queryIncList`;
            break;
          case 'reminder':
            method = 'post';
            url = `${apis.softwareApplication}reminder`;
            break;
          case 'revoke':
            method = 'post';
            url = `${apis.softwareApplication}revoke`;
            break;
          default:
            break;
        }
        const timeStart = new Date();
        if (method === 'post') {
          const { data: res, headers } = datas.data
            ? await axios.post(url, datas.data, this.state.headers)
            : await axios.post(url, this.state.headers);
          const timeCost = new Date().getTime() - timeStart.getTime();
          if (res.code !== 1) {
            ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, false);
            return { status: 'failed', data: res.msg };
          }
          ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, true);
          return { status: 'success', data: res.data };
        }
        const { data: res, headers } = datas.data
          ? await axios.get(`${url}/${datas.data}`, this.state.headers)
          : await axios.get(url, this.state.headers);
        if (res.code !== 1) {
          ubtSendMetric(
            this.pvId,
            url,
            headers.rootmessageid,
            new Date().getTime() - timeStart.getTime(),
            false,
          );
          return { status: 'failed', data: `softApply failed: ${res.msg}` };
        }
        ubtSendMetric(
          this.pvId,
          url,
          headers.rootmessageid,
          new Date().getTime() - timeStart.getTime(),
          true,
        );
        return { status: 'success', data: res.data };
      } catch (error) {
        return { status: 'failed', data: error };
      }
    },
    async getPcGrantTime(context, device) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          apis.getPcGrantTime + device,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(
            this.pvId,
            apis.getPcGrantTime + device,
            headers.rootmessageid,
            timeCost,
            false,
          );
          return '';
        }
        ubtSendMetric(
          this.pvId,
          apis.getPcGrantTime + device,
          headers.rootmessageid,
          timeCost,
          true,
        );
        return res.data;
      } catch (error) {
        console.log('getPcGrantTime error!', error);
        return '';
      }
    },
    async getPcDeployedTask(context, device) {
      try {
        const deployList = [];
        const fixList = [];
        let timeStart = new Date();
        const { data: softRes, headers } = await axios.get(
          `${apis.getSoftDetails}SoftwareDeploy`,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(
          this.pvId,
          `${apis.getSoftDetails}SoftwareDeploy`,
          headers.rootmessageid,
          timeCost,
          true,
        );
        const deployData = softRes.code === 1 ? softRes.data : [];
        // console.log('deployData', deployData, device);
        timeStart = new Date();
        const { data: res } = await axios.post(
          apis.getPcDeployedTask,
          { ci_code: device },
          this.state.headers,
        );
        if (res.code === 1) {
          ubtSendMetric(
            this.pvId,
            apis.getPcDeployedTask,
            headers.rootmessageid,
            new Date().getTime() - timeStart.getTime(),
            true,
          );
          res.data.forEach((item) => {
            deployData.forEach((itm) => {
              if (itm.status === 1 && itm.regName === item.taskName) {
                if (item.type === 'deploy') {
                  deployList.push(itm);
                } else {
                  fixList.push(itm);
                }
              }
            });
          });
        }
        context.commit('setDeployCount', deployList.length);
        context.commit('setFixCount', fixList.length);
        context.commit('setDeployTask', deployList);
        context.commit('setFixTask', fixList);
        return 'success';
      } catch (error) {
        return 'error';
      }
    },
    async getRecommendSoftware(context) {
      try {
        const timeStart = new Date();
        const url = `${apis.getRecommendSoftware}?lan=cn`;
        const { data: res, headers } = await axios.get(url, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(
            this.pvId,
            apis.getRecommendSoftware,
            headers.rootmessageid,
            timeCost,
            false,
          );
          return 'failed';
        }
        ubtSendMetric(this.pvId, apis.getRecommendSoftware, headers.rootmessageid, timeCost, true);
        if (res.data.length > 0) {
          context.commit('setRecommendSoftware', res.data);
        }
        const urlEn = `${apis.getRecommendSoftware}?lan=en`;
        const { data: resEn } = await axios.get(urlEn, this.state.headers);
        if (resEn.data.length > 0) {
          context.commit('setRecommendSoftwareEn', resEn.data);
        }
        return 'success';
      } catch (error) {
        return 'error';
      }
    },
    async getCallTestResult(context, type) {
      try {
        const timeStart = new Date();
        const api = type === 'IN' ? apis.callInTest : apis.callOutTest;
        const { data: res, headers } = await axios.get(api, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code !== 1) {
          ubtSendMetric(this.pvId, api, headers.rootmessageid, timeCost, false);
          return res.msg;
        }
        ubtSendMetric(this.pvId, api, headers.rootmessageid, timeCost, true);
        return 'success';
      } catch (error) {
        return error;
      }
    },
    async getCallTestResultQuery(context, type) {
      try {
        const timeStart = new Date();
        const api = type === 'IN' ? apis.callInTestQuery : apis.callOutTestQuery;
        const { data: res, headers } = await axios.get(api, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code === 1) {
          ubtSendMetric(this.pvId, api, headers.rootmessageid, timeCost, true);
          return res.data;
        }
        ubtSendMetric(this.pvId, api, headers.rootmessageid, timeCost, false);
        return '';
      } catch (error) {
        return '';
      }
    },
    async reportError(context, datas) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.post(
          apis.reportError,
          datas,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        console.log(datas);
        // const res = { code: 1, msg: '', data: 'INCxxxxxxxxxxxxxxxx' };
        console.log('reportError>>>> ', res);
        context.commit('setDebugInfos', ['ReportError', res]);
        if (res.code === 1) {
          ubtSendMetric(this.pvId, apis.reportError, headers.rootmessageid, timeCost, true);
          context.commit('setRemedyIncNo', res.data);
          return 'success';
        }
        if (res.code === 0 && res.msg === 'too many events in progress') {
          ubtSendMetric(this.pvId, apis.reportError, headers.rootmessageid, timeCost, false);
          return 'limit';
        }
        return 'failed';
      } catch (error) {
        return 'error';
      }
    },
    async getLicenseStock(context, data) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          apis.getLicenseStock + data,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(
          this.pvId,
          apis.getLicenseStock + data,
          headers.rootmessageid,
          timeCost,
          true,
        );
        return res;
      } catch (error) {
        return error;
      }
    },
    async getUserLicense(context) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          `${apis.getUserLicense}`,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        if (res.code && res.code === 1) {
          ubtSendMetric(this.pvId, `${apis.getUserLicense}`, headers.rootmessageid, timeCost, true);
          const licenseList = tools.sortByKeyDesc(res.data, 'applyTime');
          context.commit('setUserLicenses', licenseList);
        }
      } catch (error) {
        console.log('error in getUserLicense', error);
      }
    },
    async recycleLicense(context, datas) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.post(
          apis.recycleLicense,
          datas,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, apis.recycleLicense, headers.rootmessageid, timeCost, true);
        return res;
      } catch (error) {
        console.log('error in recycleLicense', error);
        return '';
      }
    },
    async applyPcAdmin(context, datas) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.post(apis.pcAdmin, datas, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, apis.pcAdmin, headers.rootmessageid, timeCost, true);
        return res;
      } catch (error) {
        console.log('error in applyPcAdmin', error);
        return '';
      }
    },
    async getPcAdminApply(context, datas) {
      try {
        const timeStart = new Date();
        const url = `${apis.getPcAdminApply}?empCode=${datas.empcode}&pcName=${datas.pcName}`;
        const { data: res, headers } = await axios.get(url, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, true);
        return res; // 0 applying, 1: approved, -1: Cancel, -2: Refused
      } catch (error) {
        console.log('error in getPcAdminApply', error);
        return '';
      }
    },
    async getUserLeaderFive(context, empcode) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.get(
          `${apis.getUserLeaderFive}?empCode=${empcode}`,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(
          this.pvId,
          `${apis.getUserLeaderFive}?empCode=${empcode}`,
          headers.rootmessageid,
          timeCost,
          false,
        );
        return res;
      } catch (error) {
        console.log('error in getUserLeaderFive', error);
        return '';
      }
    },
    async saveDeployLog(context, datas) {
      try {
        const timeStart = new Date();
        const { data: res, headers } = await axios.post(
          apis.addDeployedPc,
          datas,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, apis.addDeployedPc, headers.rootmessageid, timeCost, true);
        console.log('addDeployedPc', datas, res);
        return res.code === 1 ? 'OK' : 'failed';
      } catch (error) {
        return 'error';
      }
    },
    async saveLog({ state }, datas) {
      try {
        const timeStart = new Date();
        const logs = datas;
        logs.lan = state.languages.lan;
        logs.account = this.state.userInfo.username;
        logs.empDomain = this.state.userInfo.empDomain;
        logs.empCity = this.state.userInfo.empCity;
        logs.pcName = this.state.deviceName;
        const { data: res, headers } = await axios.post(apis.saveLog, logs, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, apis.saveLog, headers.rootmessageid, timeCost, true);
        console.log(`saveLog > ${logs.title}`, res);
      } catch (error) {
        console.log('saveLog error!', error);
      }
    },
    async saveVersionLog(context, datas) {
      try {
        const timeStart = new Date();
        const logs = datas;
        const { data: res, headers } = await axios.post(apis.versionLog, logs, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, apis.versionLog, headers.rootmessageid, timeCost, true);
        console.log('versionLog', res);
      } catch (error) {
        console.log('saveVersionLog error!', error);
      }
    },
    async getSoftAllHashList(context, softId) {
      try {
        const timeStart = new Date();
        const url = `${apis.getVersionHash}?softwareId=${softId}`;
        const { data: res, headers } = await axios.get(url, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, apis.versionLog, headers.rootmessageid, timeCost, true);
        console.log('getSoftAllHashList', res);
        return res.data;
      } catch (error) {
        console.log('saveVersionLog error!', error);
        return [];
      }
    },
    async searchSoft({ state }, searchValue) {
      try {
        const timeStart = new Date();
        const url = `${apis.getSoftware}?name=${searchValue}&lan=${state.languages.lan}&empCode=${state.userInfo.empcode}`;
        const { data: res, headers } = await axios.get(url, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, true);
        if (res.code !== 1) {
          return [];
        }
        return res.data;
      } catch (error) {
        console.log('searchSoft error!', error);
        return [];
      }
    },
    async getAllSoftList(context, lan) {
      try {
        const timeStart = new Date();
        const url = `${apis.getSoftDetails}${lan}`;
        const { data: res, headers } = await axios.get(url, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, true);
        return res.data;
      } catch {
        return [];
      }
    },
    async checkAdminReboot(context, datas) {
      try {
        const timeStart = new Date();
        const url = apis.checkAdminReboot;
        const { data: res, headers } = await axios.post(
          url,
          datas,
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, true);
        if (res.data) {
          return true;
        }
        return false;
      } catch {
        return false;
      }
    },
    async getSoftHashList(context, softIds) {
      try {
        const timeStart = new Date();
        const url = apis.getVersionHashList;
        const { data: res, headers } = await axios.post(
          url,
          { softwareIds: softIds },
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, true);
        return res.data;
      } catch {
        return {};
      }
    },
    async syncSelfHelp(context, qid) {
      try {
        const timeStart = new Date();
        const url = apis.syncSelfHelp;
        const res = await axios.post(
          url,
          { qid, desktopNum: this.state.deviceName, empCode: this.state.userInfo.empcode },
          this.state.headers,
        );
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, url, res.headers.rootmessageid, timeCost, true);
      } catch (error) {
        console.log(`syncSelfHelp failed, ${error.message}`);
      }
    },
    async getFigmaPermission(context) {
      try {
        const timeStart = new Date();
        const url = apis.getFigmaPermission;
        const { data: res, headers } = await axios.post(url, {}, this.state.headers);
        const timeCost = new Date().getTime() - timeStart.getTime();
        ubtSendMetric(this.pvId, url, headers.rootmessageid, timeCost, true);
        if (res.data) {
          context.commit('setFigmaPermission', res.data);
        }
      } catch {
        console.log('getFigmaPermission failed');
      }
    },
  },
});
